export enum ERROR_CODES {
  FIELD_RESOLVER_ERROR = 'FIELD_RESOLVER_ERROR',
}
